import React, { useMemo } from 'react';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WriteBackToWorkdayViaWsPlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/workday-write-back';
import { ConfigureWriteBackWorkdayViaWsJobApplicationCustomFieldPlaceToWrite } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackWorkdayViaWsJobApplicationCustomFieldPlaceToWrite';
import { ListItem } from 'libs/end-to-end/src/types/generic/generic';

export interface ConfigureWriteBackWorkdayViaWsPlaceToWriteProps
  extends ConfigureWorkflowBaseProps {
  placeToWrite: WriteBackToWorkdayViaWsPlaceToWrite | null;
  updatePlaceToWrite: (
    newPlaceToWrite: WriteBackToWorkdayViaWsPlaceToWrite | null,
  ) => void;
}

export const ConfigureWriteBackWorkdayViaWsPlaceToWrite = ({
  placeToWrite,
  updatePlaceToWrite,
  listDataSetsPattern,
  listSecretsPattern,
  organizationId,
}: ConfigureWriteBackWorkdayViaWsPlaceToWriteProps) => {
  const placeTypeList: ListItem<'none' | 'jobApplicationCustomField'>[] =
    useMemo(() => {
      return [
        { optionLabel: 'None', optionValue: 'none' },
        {
          optionLabel: 'Job Application Custom Field',
          optionValue: 'jobApplicationCustomField',
        },
      ];
    }, []);
  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <label className="block text-sm font-medium text-gray-700">
        Select a place
      </label>
      <SelectBoxWithSearch
        type="single"
        list={placeTypeList}
        label="Place Type"
        selected={placeToWrite?.type ?? 'none'}
        setSelected={(
          newSelected: 'none' | WriteBackToWorkdayViaWsPlaceToWrite['type'],
        ) => {
          updatePlaceToWrite(
            newSelected === 'none' ? null : { type: newSelected },
          );
        }}
      />
      {placeToWrite?.type === 'jobApplicationCustomField' && (
        <ConfigureWriteBackWorkdayViaWsJobApplicationCustomFieldPlaceToWrite
          placeToWrite={placeToWrite}
          updatePlaceToWrite={updatePlaceToWrite}
          listDataSetsPattern={listDataSetsPattern}
          listSecretsPattern={listSecretsPattern}
          organizationId={organizationId}
        />
      )}
    </div>
  );
};
